module.exports = __webpack_public_path__ + "media/images/instagram-white-icon2-2d7b81f7c04651a8a80769c3458bf9c1.png";